import DashRoute from "../../Component/PagesComponent/AdminCompo/DhasRoute/DashRoute";
import ProductRoute from "../../Component/PagesComponent/ProductCompo/ProductRoute/ProductRoute"

const ChildRouting = [
    ...DashRoute,
    ...ProductRoute

]

export default ChildRouting
